module.exports = __webpack_public_path__ + "static/img/IMG_20240908_070050-EFFECTS.021b3188.jpg";